import React from "react"


export default () => (

<img id="fan" class="fan lazyload" alt="赤い換気扇のロゴ" width="63" height="63"
	 src="https://elvn.imgix.net/global/fanLOGO.png?w=25"
	 data-src="https://res.cloudinary.com/e11/image/upload/v1544765900/fanLOGO.png"/>

)